// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"04d3280b","608":"6727b5f4"}[chunkId] + ".chunk.js";
};